import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function AddSelf() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // ---------------- FORM DATA ----------------
  const [formData, setFormData] = useState({
    regcmp_compliance_id: "",
    regcmp_act: "",
    regcmp_particular: "",
    regcmp_description: "",
    regcmp_start_date: "",
    regcmp_end_date: "",
    regcmp_action_date: "",
    regcmp_reminder_days: 1,

    add_escalation: false,
    regcmp_escalation_email: "",
    regcmp_escalation_reminder_days: "",

    regcmp_status: "Upcoming",
  });


  const FIELD_LABELS = {
  regcmp_compliance_id: "Compliance ID",
  regcmp_act: "Act",
  regcmp_particular: "Compliance Particular",
  regcmp_description: "Description",
  regcmp_start_date: "Start Date",
  regcmp_end_date: "End Date",
  regcmp_action_date: "Action Date",
  regcmp_reminder_days: "Reminder Days",
  regcmp_escalation_email: "Escalation Email",
  regcmp_escalation_reminder_days: "Escalation Reminder Days",
};

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [errorVisible, setErrorVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  // ---------------- DATE NORMALIZER ----------------
  const toInputDate = (value) => {
    if (!value) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

    const parts = value.split("-");
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts;
      return `${yyyy}-${mm}-${dd}`;
    }

    const d = new Date(value);
    return isNaN(d) ? "" : d.toISOString().split("T")[0];
  };

  // ---------------- LOAD SELECTED ROW ----------------
  useEffect(() => {
    const savedRow = localStorage.getItem("selectedComplianceRow");
    if (!savedRow) return;

    const row = JSON.parse(savedRow);

    setFormData((prev) => ({
      ...prev,
      regcmp_compliance_id: row.complianceId || "",
      regcmp_act: row.act || "",
      regcmp_particular: row.particular || "",
      regcmp_description: row.description || "",
      regcmp_start_date: toInputDate(row.startDate),
      regcmp_end_date: toInputDate(row.endDate),
      regcmp_action_date: toInputDate(row.actionDate),
    }));
  }, []);

  // ---------------- INPUT CHANGE ----------------
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrors({});
    setSuccessMsg("");
  };

  // ---------------- SUBMIT ----------------
 const handleSubmit = async (e) => {
  e.preventDefault();

  // 🔹 Scroll to top on submit
  window.scrollTo({ top: 0, behavior: "smooth" });

  setErrors({});
  setSuccessMsg("");

  const newErrors = {};
  if (!formData.regcmp_particular)
    newErrors.regcmp_particular = "Required";

  if (formData.add_escalation && !formData.regcmp_escalation_email) {
    newErrors.regcmp_escalation_email = "Required";
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  const payload = {
    regcmp_country: localStorage.getItem("selectedCountry"),
    regcmp_act: formData.regcmp_act,
    regcmp_particular: formData.regcmp_particular,
    regcmp_compliance_key: formData.regcmp_compliance_id,
    regcmp_description: formData.regcmp_description,
    regcmp_reminder_days: Number(formData.regcmp_reminder_days),

    regcmp_escalation_email: formData.add_escalation
      ? formData.regcmp_escalation_email
      : "",

    regcmp_escalation_reminder_days: formData.add_escalation
      ? Number(formData.regcmp_escalation_reminder_days || 0)
      : 0,
  };

  try {
  const res = await apiFetch("/compliance/add/regulatory", {
    method: "POST",
    body: JSON.stringify(payload),
  });

  // 🔴 IMPORTANT: handle logical API errors
  if (res?.error) {
    throw res;
  }

  setSuccessMsg("✅ Compliance created successfully");

  setTimeout(() => {
    navigate("/user_dashboard");
  }, 1200);
} catch (err) {
  console.error(err);

  let errorMsg =
    err?.error || "❌ Regulatory compliance already exists";

  // 🔹 Convert backend field names to user-friendly names
  if (errorMsg.startsWith("Missing field:")) {
    const backendField = errorMsg.replace("Missing field:", "").trim();
    const friendlyName = FIELD_LABELS[backendField] || backendField;
    errorMsg = `Missing field: ${friendlyName}`;
  }

  setErrors({ api: errorMsg });
}


};


  const formatDDMMYYYY = (value) => {
  if (!value) return "";
  const [yyyy, mm, dd] = value.split("-");
  return `${dd}/${mm}/${yyyy}`;
};


  // ---------------- AUTO-HIDE ERROR ----------------
  useEffect(() => {
    if (errors.api) {
      setErrorVisible(true);
      const timer = setTimeout(() => setErrorVisible(false), 4500);
      const removeTimer = setTimeout(() => setErrors({}), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [errors.api]);

  // ---------------- AUTO-HIDE SUCCESS ----------------
  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const timer = setTimeout(() => setSuccessVisible(false), 4500);
      const removeTimer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [successMsg]);

  return (
    <div className="add_compliance">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Add Regulatory Compliance</h2>

        <div className="messages-top" style={{ margin: "0 auto 1rem auto", width: "50%" }}>
          {errors.api && (
            <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
              {errors.api}
            </div>
          )}
          {successMsg && (
            <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          <label>
            Compliance ID
            <input
              type="text"
              name="regcmp_compliance_id"
              value={formData.regcmp_compliance_id}
              disabled
            />
          </label>

          <div></div>

          <label>
            Act
            <input
              type="text"
              name="regcmp_act"
              value={formData.regcmp_act}
              disabled
            />
          </label>

          <label>
            Compliance Particular
            <input
              type="text"
              name="regcmp_particular"
              value={formData.regcmp_particular}
              disabled
            />
            {errors.regcmp_particular && (
              <span className="error">{errors.regcmp_particular}</span>
            )}
          </label>

          <label>
  Start Date
  <input
    type="text"
    value={formatDDMMYYYY(formData.regcmp_start_date)}
    disabled
  />
</label>

<label>
  End Date
  <input
    type="text"
    value={formatDDMMYYYY(formData.regcmp_end_date)}
    disabled
  />
</label>

<label>
  Action Date
  <input
    type="text"
    value={formatDDMMYYYY(formData.regcmp_action_date)}
    disabled
  />
</label>


          <div></div>

          <label>
            Description
            <input
              type="text"
              name="regcmp_description"
              value={formData.regcmp_description}
              onChange={handleInputChange}
            />
          </label>

          <div></div>

          <label>
            Reminder Days
            <input
              type="number"
              name="regcmp_reminder_days"
              value={formData.regcmp_reminder_days}
              onChange={handleInputChange}
              style={{ width: "60px" }}
            />
          </label>

          <div></div>

         {/* 🔔 ADD ESCALATION */}
<div>
  <input
    type="checkbox"
    name="add_escalation"
    checked={formData.add_escalation}
    onChange={handleInputChange}
  />
  Add Escalation<sup><i>Optional</i></sup>
</div>
<div></div>

<label>
  Escalation Email
  <input
    type="email"
    name="regcmp_escalation_email"
    value={formData.regcmp_escalation_email}
    onChange={handleInputChange}
    readOnly={!formData.add_escalation} // 🔹 locked until checkbox is ticked
    style={{
      backgroundColor: formData.add_escalation ? "white" : "#f0f0f0",
      cursor: formData.add_escalation ? "text" : "not-allowed",
    }}
  />
  {errors.regcmp_escalation_email && (
    <span className="error">{errors.regcmp_escalation_email}</span>
  )}
</label>

<label>
  Escalation Reminder Days
  <input
    type="number"
    name="regcmp_escalation_reminder_days"
    value={formData.regcmp_escalation_reminder_days}
    onChange={handleInputChange}
    readOnly={!formData.add_escalation} // 🔹 locked until checkbox is ticked
    style={{
      width: "60px",
      backgroundColor: formData.add_escalation ? "white" : "#f0f0f0",
      cursor: formData.add_escalation ? "text" : "not-allowed",
    }}
  />
</label>


          <button type="submit" className="submit-btn">
            Create Compliance
          </button>
        </form>
      </div>
    </div>
  );
}
